//请自行添加语言资源
const home = {
  content:"内容",
  msg: {}
};
export default home



// WEBPACK FOOTER //
// ./src/page/home/lang/home.zh.js